<!-- <div class="card"
     style="height: calc(91vh - 140px); overflow-y: scroll; border-radius: 0px !important; padding-bottom: 50px; border: none;"> -->
<form #f="ngForm"
      (ngSubmit)="(!f.form.valid ? onValidateGeneralInfo() : 'true') && f.form.valid  &&  onSubmit($event)" #pannelForm
      appFocusFirstElement class="w-100">
  <mat-accordion #accordion="matAccordion" [multi]="true">
<!--    <div class="col-12 text-title" *ngIf="current == 2">-->
<!--      <mat-label>{{'title.resources_used' | translate}} {{convertTitleResource()}} </mat-label>-->
<!--    </div>-->
    <!-- Section: Thông tin liên hệ -->
    <mat-expansion-panel *ngIf="check == 1" expanded="true" class="mat-elevation-z0" #mePanel="matExpansionPanel">
      <mat-expansion-panel-header>
        <!-- Thông tin liên hệ -->
        <mat-panel-title class="mat-panel-title justify-content-between">
          <span>{{'title.document_info' | translate}}</span>
          <small class="form-text text-gray pull-left">(<span style="color: red;">*</span>) {{'form.info' |
            translate}}
          </small>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="row">
        <!-- Select option to choose between creating document by template or uploading -->
        <!-- Tên mẫu hợp đồng nếu có-->

        <!-- Fill service type when selected document type parent in add document upload or selected document type in add document form -->
        <!-- Loại HĐ -->
        <div class="col-4">
          <mat-form-field class="w-100"
                          [class.input-document]="isShowAddDocument"
                          [class.input-document-no]="!isShowAddDocument"
          >
            <mat-label>{{'enterprise_document_template_add_pop.cbx_service_type.lbl_service_type' | translate}}
            </mat-label>
            <mat-select #serviceTypeSelect (focusout)="(checkFocus = true)"
                        (selectionChange)="selectedChange($event)"
                        (focus)="commonService.openComboBox(checkFocus, serviceTypeSelect)" id="serviceTypeId"
                        name="serviceTypeId" [(ngModel)]="document.serviceType" #serviceTypeId="ngModel" required
                        [disabled]=" valueSelect === 0 || warningContractQuantity">
              <!-- [disabled]="selectedDocumentTypeParent && selectedDocumentTypeParent.id && valueSelect == 1 || selectedDocumentType && selectedDocumentType.id && valueSelect == 0"> -->
              <mat-option>
                <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                       [placeholderLabel]="'search_form.search' | translate"
                                       [formControl]="serviceTypesFilterCtrl">
                </ngx-mat-select-search>
              </mat-option>
              <div class="service-type-loading" *ngIf="isServiceTypesLoading">
                <i class="fa fa-circle-o-notch fa-spin"></i>
              </div>
              <mat-option *ngFor="let serviceType of filteredServiceTypes | async" [value]="serviceType.id"
                          (click)="this.commonService.closeDropdownList(this.serviceTypeSelect)">
                {{serviceType.name}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="f.submitted || serviceTypeId.invalid || serviceTypeId.errors?.required">
              {{'validation.service_type' | translate}}
            </mat-error>
          </mat-form-field>
          <ng-container *ngIf="isShowAddDocument">
<!--            Dấu + bên dưới-->
            <mat-icon
              matSuffix
              matTooltip="{{'enterprise_contract.panel_document.help_document_name.tooltip' | translate}}"
              class="custom-position-for-icon"
              style="cursor: pointer;"
              (click) = "openDialogAdd()"
            >add_circle_outline
            </mat-icon>
          </ng-container>

        </div>
        <div class="col-4">
          <!-- Tên HĐ -->
          <mat-form-field class="w-100" style="width: -webkit-calc(100% - 35px) !important;
                                              width: -moz-calc(100% - 35px) !important;
                                              width: calc(100% - 35px) !important;">
            <input (focusout)="document.name = document.name.trim()" matInput
                   placeholder="{{'form.doc_name' | translate}}" autocomplete="off" type="text" name="documentName"
                   #documentName="ngModel" [(ngModel)]="document.name" required
                   [ngClass]="{ 'is-invalid': f.submitted || documentName.invalid }" maxlength="100"
                   [disabled]="warningContractQuantity"/>
            <button mat-button *ngIf="document.name" type="button" matSuffix mat-icon-button aria-label="Clear"
                    (click)="document.name=''">
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="f.submitted || documentName.invalid">
                      <span *ngIf="documentName?.errors?.required" class="text-error">
                        {{'validation.document_type_name' | translate}}
                      </span>
            </mat-error>
          </mat-form-field>
          <mat-icon matSuffix
                    matTooltip="{{'enterprise_contract.panel_document.help_document_name.tooltip' | translate}}"
                    class="custom-position-for-icon"
                    (click)="createTplModal(tplHelpTitle, tplHelpContent, tplHelpFooter)">help_outline
          </mat-icon>
          <ng-template #tplHelpTitle>
            <span>{{'enterprise_contract.panel_document.help_document_name.modal_title' | translate}}</span>
          </ng-template>
          <ng-template #tplHelpContent>
            <p>{{'enterprise_contract.panel_document.help_document_name.modal_content1' | translate}}</p>
            <p>{{'enterprise_contract.panel_document.help_document_name.modal_content2' | translate}}
              <b>{{'enterprise_contract.panel_document.help_document_name.modal_content3' | translate}}</b>
              {{'enterprise_contract.panel_document.help_document_name.modal_content4' | translate}}
            </p>
          </ng-template>
          <ng-template #tplHelpFooter>
            <button nz-button nzType="primary" (click)="destroyTplModal()">
              {{'button.close' | translate}}
            </button>
          </ng-template>
        </div>
        <div class="col-4">
          <!-- Mã HĐ -->
          <mat-form-field class="w-100">
            <input (focusout)="document.code = document.code.trim()" matInput
                   placeholder="{{'form.doc_code' | translate}}" autocomplete="off" type="text" name="code"
                   #code="ngModel" [(ngModel)]="document.code" [pattern]="documentCodePattern"
                   [ngClass]="{ 'is-invalid': f.submitted || code.invalid }" required maxlength="50" id="code"
                   [disabled]="warningContractQuantity || isOnAutoNumber"/>
            <button mat-button *ngIf="document.code && !isOnAutoNumber" type="button" matSuffix mat-icon-button aria-label="Clear"
                    (click)="document.code=''">
              <mat-icon>close</mat-icon>
            </button>
            <button mat-button *ngIf=" isOnAutoNumber && !refreshContractCode && isUpdate" type="button" matSuffix mat-icon-button
                    (click)="onRefreshContractCode()">
              <mat-icon  matTooltip="{{'enterprise_contract.tooltips.refresh' | translate}}" class="text-primary">refresh</mat-icon>
            </button>
            <mat-error *ngIf="(f.submitted || code.invalid) && !isOnAutoNumber">
                      <span *ngIf="code?.errors?.required" class="text-error">
                        {{'validation.document_type_code' | translate}}
                      </span>
              <span *ngIf="code?.errors?.pattern" class="text-error">
                        {{'validation.lbl_validation_document_code_format' | translate}}
                      </span>
              <span class="text-error" *ngIf="code?.errors?.duplicate">
                        {{'validation.document_code_duplicate' | translate}}
                      </span>
            </mat-error>
          </mat-form-field>
          <div *ngIf="isOnAutoNumber" class="w-100 pb-2" style="font-style: italic; transform: translateY(-10px) !important;">
            <span><strong>{{'service_type.remind_configuration.note' | translate}}</strong>
              <span *ngIf="isUpdate && refreshContractCode == false">{{'validation.note_contracts_documents_auto_update' | translate}}&nbsp;</span>
              <span *ngIf="!isUpdate">{{'validation.note_contracts_documents_auto' | translate}}&nbsp;</span>
              <span *ngIf="refreshContractCode == true">{{'validation.lbl_validation_refresh' | translate}}&nbsp;</span>
              <!-- {{'validation.error_user_confirm_bct_note_after' | translate}} -->
            </span>
          </div>
        </div>
        <div class="col-4">
          <!-- Ngày kết thúc -->
          <mat-form-field class="w-100" [class.mb-3]="valueSelect != 1">
            <mat-label>{{'form.expired_date' | translate}}</mat-label>
            <input matInput [matDatepicker]="expiredDate1" name="expiredDate" #expiredDate="ngModel"
                   [min]="minDate"
                   (change)="this.commonService.resetDatePicker(pickerInput.value, this.ngForm.controls['expiredDate'])"
                   [(ngModel)]="document.expiredDate" [ngClass]="{ 'is-invalid': expiredDate.invalid }"
                   (keyup)="expiredDateChange(pickerInput.value)" maxlength="10" #pickerInput
                   [disabled]="warningContractQuantity"/>
            <mat-datepicker-toggle matSuffix [for]="expiredDate1">
              <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                 [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
            </mat-datepicker-toggle>
            <mat-datepicker #expiredDate1></mat-datepicker>
            <mat-error *ngIf="f.submitted || expiredDate.invalid">
                      <span *ngIf="expiredDate.invalid" class="text-error">
                        {{ getErrorDateMessage(pickerInput.value, true) }}
                      </span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-4" *ngIf="cecaEnable && !isNotAttestedUser">
          <mat-form-field class="w-100 isConfirmBCTSelect">
            <mat-label>{{'ceca.lb_cbb_send_BCT' | translate}} </mat-label>
            <mat-select #isConfirmBCTSelect (focusout)="(checkFocus = true)"
                        (selectionChange)="isConfirmBCTChange()"
                        (focus)="commonService.openComboBox(checkFocus, isConfirmBCTSelect)" id="isConfirmBCT"
                        name="isConfirmBCT" [(ngModel)]="document.isConfirmBCT" #isConfirmBCT="ngModel" required>
<!--              <mat-select #isConfirmBCT (focusout)="(checkFocus = true)"-->
<!--                          (selectionChange)="checkFocus = false"-->
<!--                          (focus)="commonService.openComboBox(checkFocus, isConfirmBCT)" [(value)]="document.isConfirmBCT" required>-->
              <!-- [disabled]="selectedDocumentTypeParent && selectedDocumentTypeParent.id && valueSelect == 1 || selectedDocumentType && selectedDocumentType.id && valueSelect == 0"> -->
              <mat-option [value]="true" (click)="this.commonService.closeDropdownList(this.isConfirmBCTSelect)">
                {{'ceca.option_yes' | translate}}
              </mat-option>
              <mat-option [value]="false" (click)="this.commonService.closeDropdownList(this.isConfirmBCTSelect)">
                {{'ceca.option_no' | translate}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="f.submitted && isConfirmBCT?.invalid && isConfirmBCT?.errors.required">
              Bắt buộc chọn gửi lên trục hay không
            </mat-error>
          </mat-form-field>
          <div class="w-100 pb-2" *ngIf="document.isConfirmBCT" style="font-style: italic; transform: translateY(-10px) !important;">
            <span><strong>{{'service_type.remind_configuration.note' | translate}}</strong>
              {{'validation.error_user_confirm_bct_note' | translate}}&nbsp;
              <!-- {{'validation.error_user_confirm_bct_note_after' | translate}} -->
            </span>
          </div>
          <div class="w-100 pb-2" *ngIf="!document.isConfirmBCT" style="font-style: italic; transform: translateY(-10px) !important;">
            <span><strong>{{'service_type.remind_configuration.note' | translate}}</strong>
              {{'validation.error_user_inconfirm_bct_note' | translate}}</span>
          </div>
          </div>
        <div class="col-4" *ngIf="valueSelect === 0">
          <mat-form-field class="w-100">
            <mat-label>{{'form.doc_type' | translate}}</mat-label>
            <input matInput [(ngModel)]="selectedDocumentType.name" [ngModelOptions]="{standalone: true}"
                   disabled>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <mat-form-field class="w-100" style="position: relative;">
            <textarea cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="2" style="padding-right: 30px; min-height: 28px !important; height: 28px;" (focusout)="document.summary = document.summary.trim()" rows="1" matInput
              [placeholder]="'form.contract_summary' | translate" rows="1" type="text" name="summary" id="summary"
              [(ngModel)]="document.summary" maxlength="500" spellcheck="false"></textarea>
              <button style="position: absolute; top: 5px; right: 14px;" mat-button *ngIf="document.summary" type="button" mat-icon-button aria-label="Clear"
                    (click)="document.summary=''">
                <mat-icon style="font-size: 16px;">close</mat-icon>
              </button>
          </mat-form-field>
        </div>
      </div>
    </mat-expansion-panel>

    <div class="row" *ngIf="check == 2">
      <div class="w-50">
        <mat-expansion-panel class="mat-elevation-z0" *ngIf="document.formType != 'CONTRACT_TERMINATION' || (contractTerminations.length > 0 && document.formType != 'CONTRACT_TERMINATION' && flagCopy)">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'form.digital_contract.document_parent' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-accordion #accordion="matAccordion" [multi]="true">
            <div class="" >
              <div class="w-100 ">
                <form nz-frm>
                  <nz-table #editRowInternalTable nzBordered [nzData]="dataDocumentParent" [nzShowPagination]="false" [nzNoResult]="contentEmptyTable1"
                            [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
                    <thead>
                    <tr>
                      <th class="text-center" nzWidth="25px">
                        {{
                          "enterprise_contract.panel_document.table_users.header.order"
                            | translate
                        }}
                      </th>
                      <th class="text-center" nzWidth="60%">
                        {{
                          "form.digital_contract.document_information"
                            | translate
                        }}
                      </th>
                      <th class="text-center" nzWidth="100px">{{ 'search_form.status' | translate}}</th>
                      <th class="text-center">
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let data of editRowInternalTable.data; let i = index" class="editable-row">
                      <!-- TT -->
                      <td class="text-center">{{ i + 1 }}</td>
                      <!-- Tên -->
                      <td class="word-break-line">
                        <div class="editable-cell d-flex align-items-center">
                          <div style="margin-right: 12px;">
                            <svg *ngIf="data.isContractShare" width="20" height="20" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" matTooltip="{{'contract_share_partner.breadcrumb' | translate}}">
                              <path d="M9 8.54C8.62 8.54 8.28 8.69 8.02 8.925L4.455 6.85C4.48 6.735 4.5 6.62 4.5 6.5C4.5 6.38 4.48 6.265 4.455 6.15L7.98 4.095C8.25 4.345 8.605 4.5 9 4.5C9.83 4.5 10.5 3.83 10.5 3C10.5 2.17 9.83 1.5 9 1.5C8.17 1.5 7.5 2.17 7.5 3C7.5 3.12 7.52 3.235 7.545 3.35L4.02 5.405C3.75 5.155 3.395 5 3 5C2.17 5 1.5 5.67 1.5 6.5C1.5 7.33 2.17 8 3 8C3.395 8 3.75 7.845 4.02 7.595L7.58 9.675C7.555 9.78 7.54 9.89 7.54 10C7.54 10.805 8.195 11.46 9 11.46C9.805 11.46 10.46 10.805 10.46 10C10.46 9.195 9.805 8.54 9 8.54Z" fill="black"/>
                            </svg>
                            <svg *ngIf="!data.isContractShare" width="20" height="20" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" matTooltip="{{'contract_share_partner.internal_contract' | translate}}">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.99894 0.5H9.95711L12 2.54289V12.5H8.5V11.5H11V4H8.5V1.5H2.99894V4H1.99894V0.5ZM9.5 1.5V3H11V2.95711L9.54289 1.5H9.5ZM4.5 6C3.94772 6 3.5 6.44772 3.5 7V7.5H5.5V7C5.5 6.44772 5.05228 6 4.5 6ZM6.5 7.5V7C6.5 5.89543 5.60457 5 4.5 5C3.39543 5 2.5 5.89543 2.5 7V7.5H1.5V12.5H7.5V7.5H6.5ZM6.5 8.5H2.5V11.5H6.5V8.5ZM5 9.5V10.5H4V9.5H5Z" fill="black"/>
                            </svg>
                          </div>
                          <div class="row-icon" style="flex: 1;" [ngStyle]="{ 'text-decoration': data.isRevokeContractShare ? 'line-through' : 'none'}"> {{ data.code }}
                            - {{ data.name }}
                          </div>
                          <div *ngIf="data.isRevokeContractShare" style="height: 20px;">
                            <svg matTooltip="{{ 'contract_share_partner.revoked_tooltip' | translate }}" width="20" height="20" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.125 6.3125C1.125 3.72391 3.22391 1.625 5.8125 1.625C8.40109 1.625 10.5 3.72391 10.5 6.3125C10.5 8.90109 8.40109 11 5.8125 11C3.22391 11 1.125 8.90109 1.125 6.3125ZM5.8125 2.375C3.63812 2.375 1.875 4.13812 1.875 6.3125C1.875 8.48688 3.63812 10.25 5.8125 10.25C7.98688 10.25 9.75 8.48688 9.75 6.3125C9.75 4.13812 7.98688 2.375 5.8125 2.375Z" fill="#CD002A"/>
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.78125 5.65625C4.78125 5.44914 4.94914 5.28125 5.15625 5.28125H5.90625C6.11336 5.28125 6.28125 5.44914 6.28125 5.65625V8.375C6.28125 8.58211 6.11336 8.75 5.90625 8.75C5.69914 8.75 5.53125 8.58211 5.53125 8.375V6.03125H5.15625C4.94914 6.03125 4.78125 5.86336 4.78125 5.65625Z" fill="#CD002A"/>
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 8.46875C4.5 8.26164 4.66789 8.09375 4.875 8.09375H6.9375C7.14461 8.09375 7.3125 8.26164 7.3125 8.46875C7.3125 8.67586 7.14461 8.84375 6.9375 8.84375H4.875C4.66789 8.84375 4.5 8.67586 4.5 8.46875Z" fill="#CD002A"/>
                              <path d="M5.8125 3.54688C5.69198 3.54688 5.57416 3.58261 5.47395 3.64957C5.37374 3.71653 5.29563 3.8117 5.24951 3.92305C5.20339 4.0344 5.19132 4.15693 5.21483 4.27513C5.23835 4.39334 5.29638 4.50192 5.38161 4.58714C5.46683 4.67237 5.57541 4.7304 5.69362 4.75392C5.81182 4.77743 5.93435 4.76536 6.0457 4.71924C6.15705 4.67312 6.25222 4.59501 6.31918 4.4948C6.38614 4.39459 6.42188 4.27677 6.42188 4.15625C6.42188 3.99463 6.35767 3.83964 6.24339 3.72536C6.12911 3.61108 5.97412 3.54688 5.8125 3.54688Z" fill="#CD002A"/>
                            </svg>
                          </div>
                        </div>
                      </td>
                      <td class="text-center">
                        <span *ngIf="data.status == 1">{{ 'search_form.draft' | translate}}</span>
            <span *ngIf="data.status == 2">{{ 'search_form.processing' | translate}}</span>
            <span *ngIf="data.status == 3">{{ 'search_form.denied_sign' | translate}}</span>
            <span *ngIf="data.status == 4 && data.contractTerminationStatus != 2 && data.contractTerminationStatus != 4">{{ 'search_form.finish' | translate}}</span>
            <span *ngIf="data.status == 5">{{ 'search_form.cancelled' | translate}}</span>
            <span *ngIf="data.status == 6">{{ 'search_form.wait_confirm_enterprice_no_moit' | translate}}</span>
            <span *ngIf="data.status == 7">{{ 'contract_share_partner.issued' | translate}}</span>
            <span *ngIf="data.status == 8">{{ 'contract_share_partner.issued' | translate}}</span>
            <span *ngIf="data.status == 9">{{ 'search_form.wait_confirm_enterprice_no_moit' | translate}}</span>
            <span *ngIf="data.status == 4 && data.contractTerminationStatus == 2">{{ 'contract_terminate.terminating' | translate}}</span>
            <span *ngIf="data.status == 4 && data.contractTerminationStatus == 4">{{ 'contract_terminate.terminated' | translate}}</span>
                      </td>
                      <!-- Action -->
                      <td class="td-nz-icon text-center">
                        <button mat-icon-button (click)="viewContract(data)" *ngIf="!data.isRevokeContractShare; else noPermission"  aria-label="View" style="color: #07736C">
                          <mat-icon>
                            visibility
                          </mat-icon>
                        </button>
                        <button (click)="onClickDeleteElementRecordInternalUser(data.id)"
                                *ngIf="data.id " aria-label="Clear"
                                mat-button mat-icon-button matSuffix style="color: #ee0033"
                                type="button">
                          <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                        </button>
                        <ng-template #noPermission>
                          <button mat-icon-button disabled>
                            <span> </span>
                          </button>
                        </ng-template>
                      </td>
                    </tr>
                    <tr class="editable-row">
                      <!-- TT -->
                      <td class="text-center">&nbsp;</td>
                      <!-- Tên -->
                      <td colspan="3">
                        <div>
                          <nz-input-group [nzSuffix]="suffixPartyInput">
                            <input nz-input [(ngModel)]="inputInternalDocumentsValue" (input)="getParentContractNew($event)"
                                   [nzAutocomplete]="autoInternalUserSearching" [ngModelOptions]="{ standalone: true }" placeholder="{{
                        'placeholder.document_parent' | translate
                      }}" #autocompleteInput id="inputUser1" />
                            <nz-autocomplete #autoInternalUserSearching>
                              <nz-auto-option *ngFor="let user of parentContracts"
                                              (selectionChange)="autocompleteInternalUserSelected($event, user)"
                                              [nzValue]="''">
                                <div class="d-flex">
                                  <span style="line-height: 20px">
                                      {{ user.code }} - {{ user.name }}
                                    </span>
                                </div>
                              </nz-auto-option>
                            </nz-autocomplete>
                          </nz-input-group>
                          <ng-template #suffixPartyInput>
                            <nz-spin *ngIf="nzCheckLoadingParty1" nzSimple [nzIndicator]="indicatorPartyInput"></nz-spin>
                          </ng-template>
                          <ng-template #indicatorPartyInput><i class="nz-icon-font" nz-icon nzType="loading"
                                                               style="font-size: 24px"></i>
                          </ng-template>
                        </div>
                      </td>
                      <!-- Thực hiện -->
                      <!--                      <td class="td-nz-icon text-center">&nbsp;</td>-->
                    </tr>
                    </tbody>
                  </nz-table>
                  <ng-template #contentEmptyTable1 ></ng-template>
                </form>
              </div>
            </div>
          </mat-accordion>
        </mat-expansion-panel>
        <mat-expansion-panel class="mat-elevation-z0" *ngIf="document.formType == 'CONTRACT_TERMINATION' || (contractTerminations.length > 0 && document.formType != 'CONTRACT_TERMINATION' && !flagCopy)">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'contract_terminate.contract_liquidated' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-accordion #accordion="matAccordion" [multi]="true">
            <div class="" >
              <div class="w-100 ">
                <form nz-frm>
                  <nz-table #contractTerminationsTable nzBordered [nzData]="contractTerminations" [nzShowPagination]="false"
                            [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
                    <thead>
                    <tr>
                      <th class="text-center" nzWidth="25px">
                        {{
                          "enterprise_contract.panel_document.table_users.header.order"
                            | translate
                        }}
                      </th>
                      <th class="text-center" nzWidth="75%">
                        {{
                          "form.digital_contract.document_information"
                            | translate
                        }}
                      </th>
                      <th class="text-center">
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let data of contractTerminationsTable.data; let i = index" class="editable-row">
                      <!-- TT -->
                      <td class="text-center">{{ i + 1 }}</td>
                      <!-- Tên -->
                      <td class="word-break-line">
                        <div class="editable-cell d-flex align-items-center">
                          <div class="row-icon"> 
                            <span style="color: blue; text-decoration: underline; cursor: pointer;" role="button" (click)="goToContractLiquidated(data.id)" target="_parent">{{ data.code }} - {{ data.name }}</span>
                          </div>
                        </div>
                      </td>
                      <!-- Action -->
                      <td class="td-nz-icon text-center">
                        <button mat-icon-button (click)="viewContract(data)" aria-label="View" style="color: #07736C">
                          <mat-icon>
                            visibility
                          </mat-icon>
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </nz-table>
                </form>
              </div>
            </div>
          </mat-accordion>
        </mat-expansion-panel>
      </div>
      <div class="w-50">
        <div class="col-12">
          <app-record-party-sign [check]="2"></app-record-party-sign>
        </div>
        <div class="col-12">
          <mat-expansion-panel class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title class="mat-panel-title">
                {{'contract_share_partner.share_contracts_with_partners' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <app-share-partner-picker [selectedPartners]="RECORD_SHARE_PARTNER"
                (selectedPartnersChange)="onSharePartnersChange($event)"></app-share-partner-picker>
          </mat-expansion-panel>
        </div>
      </div>

      <div class="col-12" style="padding-right: 2.75rem;">
        <mat-expansion-panel class="mat-elevation-z0">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'form.attach_file_list' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-accordion #accordion="matAccordion" [multi]="true">
            <app-upload-multi-file-attachments (hasChange)="onNewUploadChange($event)" [isAttachFileForDocument]="true"
                                   [arrAttachments]="this.document.newUploadContractAttachments"
                                   [typeCreateContract]="this.createContractService.createContractType.getValue() ? this.createContractService.createContractType.getValue() : document.typeId"
                                   [isEdit]="!!document.id"
                                   [isCopy]="flagCopy == 'true' ? true : false"
                                   [maxSize]="maxSize"
                                   [checkMan]="check == 2?true:false"
                                   [messageError]="messageError"
                                   (click)="onClickUpload()">
            </app-upload-multi-file-attachments>
            <mat-error class="text-error" *ngIf="duplicatedUploadFileNames?.length > 0">
              <span>{{duplicatedUploadFileTitle}}</span>
              <ul>
                <li *ngFor="let err of duplicatedUploadFileNames">
                  {{err}}
                </li>
              </ul>
            </mat-error>
            <mat-hint class="hint-text d-flex justify-content-center">
              {{'hint.attach_accept_pdf_image_email' | translate}}
            </mat-hint>
          </mat-accordion>

          <!-- list contract attchments-->
          <!-- <div class="mt-2 fix-width" *ngFor="let item of document.contractAttachments">
            <ng-container *ngIf="item.id === null; else isFileSaved">
              <em class="fa fa-file fa-fw text-primary"></em>
              <span [matTooltip]="item.fileName"> {{item.fileName}}</span>
            </ng-container>
            <ng-template #isFileSaved>
              <a (click)="downloadFile(item.id, item.fileName)">
                <em class="fa fa-download fa-fw text-primary" matTooltip="{{'tooltips.download' | translate}}"></em>
              </a>
              <span [matTooltip]="item.fileName"> {{item.fileName}}</span>
            </ng-template>
          </div> -->
        </mat-expansion-panel>
      </div>
    </div>
    <!-- Liên kết đến HĐ cha (đã có) -->

    <!--Section: Danh sách tệp đính kèm -->

  </mat-accordion>
  <button type="submit" (click)="onSubmit($event)" #panelSubmit style="display: none;"></button>
</form>
